export default __webpack_public_path__ + "8faa11ec5f62a095c0ed4f1191859d70.woff2";